export default __webpack_public_path__ + "static/media/divine.5bba96af.png";